





























































import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import UploadComponent from "../../../components/UploadComponent/index.vue";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "AttachmentWidget",
  components: { UploadComponent, MagicValidator }
})
export default class AttachmentWidget extends WidgetBase implements App.PuttedWidgetComponent {
  setValue(value: string) {
    console.log(value);
  }
}
